module.exports = __webpack_public_path__ + "img/noDirectories.95b49d64.png";